/**
 * Cliente: POST /api/capture-checkout-email (punto autoritativo server-side).
 * No duplica captureAttribution — el servidor emite checkout_almost_purchased.
 */

import { buildCheckoutEmailCaptureContext } from "@/lib/buildCheckoutEmailCaptureContext";
import { getPostHogCorrelationIdsPostHog } from "@/lib/posthogAnalytics";

export interface CaptureCheckoutEmailForRecoveryInput {
  email?: string;
  /** Stripe Checkout session id (cs_...) — requerido para provider stripe */
  sessionId?: string;
  /** Siempre Stripe en producción (MercadoPago deshabilitado). */
  provider?: "stripe";
  planTier?: string;
  flowName?: string;
  country?: string;
  amount?: number;
  currency?: string;
  dualVariantId?: string;
  dualVariantGeoScope?: string;
  dualVariantGeoCode?: string;
  dualAbBucket?: string;
}

export function captureCheckoutEmailForRecovery(
  input: CaptureCheckoutEmailForRecoveryInput,
): void {
  if (typeof window === "undefined") return;

  const email = input.email?.trim().toLowerCase();
  const sessionId = input.sessionId?.trim();

  if (!sessionId) return;
  if (!email?.includes("@")) return;

  const ph = getPostHogCorrelationIdsPostHog();
  const ctx = buildCheckoutEmailCaptureContext();

  void fetch("/api/capture-checkout-email", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      email,
      session_id: sessionId,
      provider: "stripe",
      plan_tier: input.planTier || "vip",
      flow_name: input.flowName,
      country: input.country,
      amount: input.amount,
      currency: input.currency,
      posthog_session_id: ph.session_id,
      posthog_distinct_id: ph.distinct_id,
      ph_session_id: ph.session_id,
      ph_distinct_id: ph.distinct_id,
      ph_session_replay_url: ph.session_replay_url ?? ctx.metadata.ph_session_replay_url,
      dual_variant_id: input.dualVariantId,
      dual_variant_geo_scope: input.dualVariantGeoScope,
      dual_variant_geo_code: input.dualVariantGeoCode,
      dual_ab_bucket: input.dualAbBucket,
      device: ctx.device,
      language: ctx.language,
      template: ctx.template,
      hero_cta_type: ctx.hero_cta_type,
      path: ctx.path,
      referrer: ctx.referrer,
      landing_url: ctx.landing_url,
      metadata: ctx.metadata,
    }),
    keepalive: true,
  }).catch(() => {});
}